import {takeEvery} from 'redux-saga/effects'
import {
  DISCONNECT_KENZER_ROOTS,
  GENERATE_KENZER_ROOTS_KEY,
  GET_KENZER_ROOTS_INTEGRATION,
  LAUNCH_KENZER_ROOTS_SSO,
  SAVE_KENZER_ROOTS_CONFIG,
} from 'setup/redux/Actions/SchoolIntegration/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_KENZER_ROOTS_INTEGRATION, fetchData)
  yield takeEvery(GENERATE_KENZER_ROOTS_KEY, fetchData)
  yield takeEvery(SAVE_KENZER_ROOTS_CONFIG, fetchData)
  yield takeEvery(DISCONNECT_KENZER_ROOTS, fetchData)
  yield takeEvery(LAUNCH_KENZER_ROOTS_SSO, fetchData)
}

export default dataSaga
